import * as i0 from "@angular/core";
export class MobileProfileStore {
}
MobileProfileStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MobileProfileStore_Factory() { return new MobileProfileStore(); }, token: MobileProfileStore, providedIn: "root" });
export var MobileProfileStoreKeys;
(function (MobileProfileStoreKeys) {
})(MobileProfileStoreKeys || (MobileProfileStoreKeys = {}));
